import { BreadcrumbItem } from "common/breadcrumb/breadcrumb-item";

type ViewableProcess = stages.process.ViewableProcess;
type ProcessView = stages.process.ProcessView;
type ProcessTreeItem = stages.process.ProcessTreeItem;

export abstract class ViewableBreadcrumbService {
	newBreadcrumbItems(selfView: ProcessView, addSelf: boolean, isEditing: boolean): BreadcrumbItem[] {
		const { transitiveParents, process } = selfView;
		const parentPath: BreadcrumbItem[] = [];
		if (transitiveParents) {
			const rootElement = this.getRootElement(process, isEditing);
			parentPath.push(rootElement);
			for (const transitiveParent of transitiveParents) {
				const element = this.getBreadcrumbElement(transitiveParent, isEditing);
				parentPath.push(element);
			}
		}

		if (addSelf) {
			const selfElement = this.getBreadcrumbElement(selfView, isEditing);
			parentPath.push(selfElement);
		}

		return parentPath;
	}

	abstract getRootElement(process: ViewableProcess, isEditing: boolean): BreadcrumbItem;

	abstract getBreadcrumbElement(element: ProcessTreeItem, isEditing: boolean): BreadcrumbItem;
}
